function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Array, JSON, Object, searchInputEl, searchText, showDropdown, slidOutSectionIdx) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['action-renderer'] = function(item) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("svg-icon", {
          "attrs": __vjadeStringifyAttrsIfObj({
            icon: `x`
          }),
          "on": {
            click: (ev) => $helpers.handleClickRemove(ev, item)
          },
        }));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    return {
      value: (h("div", {
        "class": {
          'options-bar': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'options-bar-top': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-input", {
            "attrs": __vjadeStringifyAttrsIfObj({
              elref: `optionsBarSearchInput`,
              icon: `search`,
              placeholder: $attr(`search-placeholder`),
              'show-clear': true,
              value: searchText,
            }),
            "props": {
              maxLength: 50,
              value: searchText,
            },
            "hook": {
              insert: $helpers.inputInserted
            },
            "on": {
              clear: () => $helpers.handleUpdateInput($helpers.DEFAULT_INPUT_STRING),
              click: () => $helpers.handleInputClick(),
              keydown: $helpers.handleKeydown,
              input: ({
                target
              }) => $helpers.handleUpdateInput(target.value),
            },
            "class": {
              'search-input': true
            },
          }));
          __jade_nodes = __jade_nodes.concat(h("mp-drop-menu", {
            "attrs": __vjadeStringifyAttrsIfObj({
              'open': showDropdown && searchText === $helpers.DEFAULT_INPUT_STRING
            }),
            "on": {
              change: ({
                detail
              }) => $helpers.handleInputDropdownChange(detail)
            },
            "class": Object.assign({}, {
              'shortened': !$helpers.isNil(slidOutSectionIdx)
            }, {
              'options-bar-input-dropdown': true
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-items-menu", {
              "attrs": __vjadeStringifyAttrsIfObj({
                'empty-message': $helpers.getEmptyState()
              }),
              "props": {
                keydownProxyEl: showDropdown && searchInputEl,
                sections: $helpers.getSearchedHistorySections($mixins)
              },
              "on": {
                clickItem: ({
                  detail
                }) => $helpers.handleSearchItemSelection(detail.item.value)
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'options': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((function() {
              var $$obj = ($attr(`options`));
              var $$eachNodes;
              var $$iterated = false;
              if (Array.isArray($$obj)) {
                $$eachNodes = $$obj.reduce(function($$eachNodes, optionConfig, idx) {
                  $$iterated = true;
                  return $$eachNodes.concat((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat((!optionConfig.hidden) ? ((function() {
                      var __jade_nodes = [];
                      const totalCount = optionConfig.sections && $helpers.getTotalNumberOfSelectedItems(optionConfig.sections);;
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "style": {
                          'min-width': `${$helpers.isNil(slidOutSectionIdx) ? 0 : optionConfig.menuWidth}px`,
                        },
                        "class": Object.assign({}, {
                          'has-count': optionConfig.showNumItems,
                        }, {
                          'option-container': true
                        }),
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat((optionConfig.type === $helpers.OptionsType.Button) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("mp-button", {
                            "attrs": __vjadeStringifyAttrsIfObj({
                              elref: `optionButton`,
                              icon: optionConfig.icon,
                              size: `large`,
                              theme: `tertiary`,
                              disabled: optionConfig.disabled,
                            }),
                            "on": {
                              click: () => $helpers.handleButtonClick(optionConfig),
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(optionConfig.name);;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this)) : (optionConfig.type === $helpers.OptionsType.Sidebar) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("mp-button", {
                            "attrs": __vjadeStringifyAttrsIfObj({
                              elref: `optionButtonSlideOut`,
                              icon: optionConfig.icon,
                              size: `large`,
                              theme: `tertiary`,
                            }),
                            "on": {
                              click: () => $helpers.handleSlideOut(idx),
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(optionConfig.name);
                            __jade_nodes = __jade_nodes.concat((optionConfig.showNumItems && totalCount) ? ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("mp-text-highlight", {
                                "attrs": __vjadeStringifyAttrsIfObj({
                                  'length': `wide`,
                                  'text': totalCount,
                                }),
                                "class": {
                                  'option-list-selected-count': true
                                },
                              }));;
                              return __jade_nodes
                            }).call(this)) : undefined);;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this)) : (optionConfig.type === $helpers.OptionsType.Select) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("mp-select", {
                            "attrs": __vjadeStringifyAttrsIfObj({
                              'menu-width': optionConfig.menuWidth || 140,
                              'menu-height': 500,
                              sections: optionConfig.sections,
                              'icon': {
                                'leftIcon': optionConfig.icon,
                                'rightIcon': 'status-light'
                              },
                              'elref': `optionsSelector`,
                              'selected-option': optionConfig.name,
                              'no-button-truncate': true,
                              multiple: optionConfig.multiple,
                              theme: `tertiary`,
                              size: `large`,
                            }),
                            "on": {
                              change: $helpers.handleClickItemFromOption
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat((optionConfig.showNumItems && totalCount) ? ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "attrs": __vjadeStringifyAttrsIfObj({
                                  'slot': `button-suffix`,
                                }),
                                "class": {
                                  'options-list-selected-count-container': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("mp-text-highlight", {
                                  "attrs": __vjadeStringifyAttrsIfObj({
                                    'length': `wide`,
                                    'text': totalCount,
                                  }),
                                  "class": {
                                    'option-list-selected-count': true
                                  },
                                }));;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this)) : undefined);;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this)) : undefined);;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this)) : undefined);;
                    return __jade_nodes
                  }).call(this));
                }, []);
              } else {
                $$eachNodes = [];
                for (var $$objKey in $$obj) {
                  (function() {
                    var idx = $$objKey;
                    if ($$obj.hasOwnProperty(idx)) {
                      $$iterated = true;
                      var optionConfig = $$obj[idx];
                      $$eachNodes = $$eachNodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat((!optionConfig.hidden) ? ((function() {
                          var __jade_nodes = [];
                          const totalCount = optionConfig.sections && $helpers.getTotalNumberOfSelectedItems(optionConfig.sections);;
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "style": {
                              'min-width': `${$helpers.isNil(slidOutSectionIdx) ? 0 : optionConfig.menuWidth}px`,
                            },
                            "class": Object.assign({}, {
                              'has-count': optionConfig.showNumItems,
                            }, {
                              'option-container': true
                            }),
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat((optionConfig.type === $helpers.OptionsType.Button) ? ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                                "attrs": __vjadeStringifyAttrsIfObj({
                                  elref: `optionButton`,
                                  icon: optionConfig.icon,
                                  size: `large`,
                                  theme: `tertiary`,
                                  disabled: optionConfig.disabled,
                                }),
                                "on": {
                                  click: () => $helpers.handleButtonClick(optionConfig),
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(optionConfig.name);;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this)) : (optionConfig.type === $helpers.OptionsType.Sidebar) ? ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                                "attrs": __vjadeStringifyAttrsIfObj({
                                  elref: `optionButtonSlideOut`,
                                  icon: optionConfig.icon,
                                  size: `large`,
                                  theme: `tertiary`,
                                }),
                                "on": {
                                  click: () => $helpers.handleSlideOut(idx),
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(optionConfig.name);
                                __jade_nodes = __jade_nodes.concat((optionConfig.showNumItems && totalCount) ? ((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("mp-text-highlight", {
                                    "attrs": __vjadeStringifyAttrsIfObj({
                                      'length': `wide`,
                                      'text': totalCount,
                                    }),
                                    "class": {
                                      'option-list-selected-count': true
                                    },
                                  }));;
                                  return __jade_nodes
                                }).call(this)) : undefined);;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this)) : (optionConfig.type === $helpers.OptionsType.Select) ? ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("mp-select", {
                                "attrs": __vjadeStringifyAttrsIfObj({
                                  'menu-width': optionConfig.menuWidth || 140,
                                  'menu-height': 500,
                                  sections: optionConfig.sections,
                                  'icon': {
                                    'leftIcon': optionConfig.icon,
                                    'rightIcon': 'status-light'
                                  },
                                  'elref': `optionsSelector`,
                                  'selected-option': optionConfig.name,
                                  'no-button-truncate': true,
                                  multiple: optionConfig.multiple,
                                  theme: `tertiary`,
                                  size: `large`,
                                }),
                                "on": {
                                  change: $helpers.handleClickItemFromOption
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat((optionConfig.showNumItems && totalCount) ? ((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "attrs": __vjadeStringifyAttrsIfObj({
                                      'slot': `button-suffix`,
                                    }),
                                    "class": {
                                      'options-list-selected-count-container': true
                                    },
                                  }, (function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(h("mp-text-highlight", {
                                      "attrs": __vjadeStringifyAttrsIfObj({
                                        'length': `wide`,
                                        'text': totalCount,
                                      }),
                                      "class": {
                                        'option-list-selected-count': true
                                      },
                                    }));;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));;
                                  return __jade_nodes
                                }).call(this)) : undefined);;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this)) : undefined);;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this)) : undefined);;
                        return __jade_nodes
                      }).call(this));
                    }
                  })();
                }
              }

              return $$eachNodes;
            })());
            __jade_nodes = __jade_nodes.concat((!$helpers.isNil(slidOutSectionIdx)) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(($helpers.getTotalNumberOfSelectedItems($attr(`options`)[slidOutSectionIdx].sections) > 0) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-button", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    size: `large`,
                    theme: `tertiary`,
                  }),
                  "on": {
                    click: $helpers.resetSectionsSlideOut,
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Clear all");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'option-bar-slide-out-clear-all-placeholder': true
                  },
                }));;
                return __jade_nodes
              }).call(this)));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat((!$helpers.isNil(slidOutSectionIdx)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'option-bar-slide-out': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'section-divider': true
              },
            }));
            __jade_nodes = __jade_nodes.concat(h("mp-items-menu", {
              "attrs": __vjadeStringifyAttrsIfObj({
                elref: `optionsBarSlideOutItems`,
                multiple: true,
                sections: $attr(`options`)[slidOutSectionIdx].sections,
              }),
              "on": {
                clickItem: $helpers.handleClickItemFromOption
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "searchInputEl" in locals ? locals.searchInputEl : typeof searchInputEl !== "undefined" ? searchInputEl : undefined, "searchText" in locals ? locals.searchText : typeof searchText !== "undefined" ? searchText : undefined, "showDropdown" in locals ? locals.showDropdown : typeof showDropdown !== "undefined" ? showDropdown : undefined, "slidOutSectionIdx" in locals ? locals.slidOutSectionIdx : typeof slidOutSectionIdx !== "undefined" ? slidOutSectionIdx : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;